import React, {useState} from 'react';
import {
  FormField,
  FormFieldHelperText,
  FormFieldLabel,
  Input,
  StackLayout
} from '@salt-ds/core';
import PageNavigation from '../../components/common/page-navigation/PageNavigation';
import Constants from '../../components/common/Constants';
import {useNavigate} from 'react-router';
import {enrollCardHolder} from '../../api/OnlineProfileRegisterationApi';

export default function OnlineProfileRegistrationAuthenticateForm(props) {
  const navigate = useNavigate();
  const [newUserId, setnewUserId] = useState({
    userId: ""
  });

  const [errors, setErrors] = useState({
    newUserId: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const {name, value} = event.target;
    setnewUserId(value);

    //Clear error when user begins to type
    if (name === 'newUserId') {
      setErrors((prevErrors) => ({
        ...prevErrors,
        newUserId: false,
      }));
    }
  };

  const isValidUserId = (userId) => {
    const lengthOfUserId = userId.length;

    if(lengthOfUserId < 6 || lengthOfUserId > 20) {
      return false;
    }

    const userIdRegEx = /^[a-zA-Z0-9]+$/;
    return userIdRegEx.test(userId);
  }

  const handleSubmit = async (event) => {
    props.setIsLoading(true);
    setIsSubmitting(true);
    event.preventDefault();
    //Validation for userId fields
    const newErrors = {
      newUserId: newUserId.userId === '' || !isValidUserId(newUserId),
    };
    setErrors(newErrors);

    //Submit the form
    if (!newErrors.newUserId) {
      try {
        const response = await enrollCardHolder(newUserId);
        sessionStorage.setItem('loginName', newUserId);
        if (response.data) {
          if (response.data.portalResponse === "success") {
            navigate('/profileRegistrationReceivePassword', {state: {newUserId, from: '/onlineProfileRegistrationCreateUserId'}});
          }
        } else if (response.error && response.error.detail) {
          setnewUserId({newUserId: ""});
          props.showErrorOnPage(response.error.detail);
        }
      } catch (error) {
        throw error;
      }
      finally {
        props.setIsLoading(false);
        setIsSubmitting(false);
      }
    }
    else {
      props.setIsLoading(false);
      setIsSubmitting(false);
    }
  };

  return (
    <form autoComplete="off" data-testid="online-profile-registration-create-user-id-form" onSubmit={handleSubmit} noValidate>
      <fieldset disabled={isSubmitting} style={{border:0, padding:0, margin:0}}>
        <StackLayout gap={3}>
          <FormField validationStatus={errors.newUserId ? "error" : undefined} className="form-layout">
            <FormFieldLabel htmlFor="newUserId">{Constants.newUserIdLabel}</FormFieldLabel>
            <Input
              id="newUserId"
              inputProps={{
                name: "newUserId",
                minLength: 6,
                maxLength: 20,
                "aria-required": "true",
                "aria-invalid": errors.newUserId ? "true" : "false",
              "aria-describedby": errors.newUserId ? "newUserId-error" : undefined,

              onKeyPress: (e) => {
                if (!/^[a-zA-Z0-9]$/.test(e.key)) {
                  e.preventDefault();
                }

              }}}
              onChange={handleChange}
              required
            />
            {
              errors.newUserId && (
                <FormFieldHelperText id="newUserId-error" role="alert">{Constants.newUserIdHelper}</FormFieldHelperText>
              )
            }
          </FormField>
        </StackLayout>
        <PageNavigation backButton={true} previousPage="/profileRegistration" currentPage={Constants.profileRegistrationCreateUserId} style={{marginTop:"50%"}} disabled={isSubmitting}/>
      </fieldset>
    </form>
  );
}